var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-col',{attrs:{"xs":_vm.same?_vm.sameNumber:_vm.xs,"sm":_vm.same?_vm.sameNumber:_vm.sm,"md":_vm.same?_vm.sameNumber:_vm.md,"lg":_vm.same?_vm.sameNumber:_vm.lg,"xl":_vm.same?_vm.sameNumber:_vm.xl}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }